module.exports = __webpack_public_path__ + "img/create.183c232c.svg";